import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Prefix backend-relative asset paths (/api/files/...) with the backend URL at render time.
// Leaves absolute (http/https/data) URLs untouched, so images survive a backend URL change.
export function assetUrl(u) {
  if (!u || typeof u !== "string") return u;
  if (/^https?:\/\//.test(u) || u.startsWith("data:")) return u;
  if (u.startsWith("/")) return `${BACKEND_URL}${u}`;
  return u;
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("om_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Ceva n-a mers. Încearcă din nou.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
